"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tints = tints;
var color_1 = require("../../color");
/**
 * Generates a tints color harmony.
 * @param {Color} color - The base color.
 * @param {number} [count=5] - The number of tints to generate (default: 5).
 * @returns {Color[]} An array containing the base color and additional lighter tints.
 */
function tints(color, count) {
    if (count === void 0) { count = 5; }
    var hsl = color.toHsl();
    var step = (100 - hsl.l) / (count - 1);
    return Array.from({ length: count }, function (_, i) {
        var newColor = __assign(__assign({}, hsl), { l: Math.min(100, hsl.l + i * step) });
        return new color_1.Color(newColor);
    });
}
